export default __webpack_public_path__ + "static/media/BMBF_de.ec9fbd66.jpg";